module.exports = __webpack_public_path__ + "202408221624/img/help_person.676ca932.jpg";